export default __webpack_public_path__ + "static/media/ansari.1cb177fc.mp4";